// extracted by mini-css-extract-plugin
export default {"RunIntroFirstScreen":"TextScreen_RunIntroFirstScreen__B9PtS","p":"TextScreen_p__jwyxu","p2":"TextScreen_p2__vckCm"};